<script lang="ts">import { Currency } from "../api/api";
import { formatLargeNumbers } from "../utils";
import { Card } from "@infinitro/card";
import { loggedIn, providerBasePath, toSiteUrl } from "@infinitro/global";
import { CurrencyIcon } from "@infinitro/icons";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
export let liveWin;
const truncatedUsername = () => {
	const username = liveWin.username || "Anonymous";
	return username.length > 14 ? `${username.slice(0, 12)}...` : username;
};
const getCurrency = () => {
	return liveWin.currency === "%future added value" ? Currency.btc : liveWin.currency;
};
</script>

<InfoCard
	noPadding
	flatBackground={true}
	width="74px"
	height="130px"
	borderRadius="8px"
	withoutBorder={true}
	backgroundImage={false}
	withoutOverflowHidden={true}
	customStylesCard="border: none;"
	noShadow={true}
>
	<div class="simple-livewin">
		<!-- Tile -->
		<a
			class="tile-link"
			href={toSiteUrl(
				`${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
				$loggedIn
			) || '#'}
		>
			<Card
				item={{
					game: liveWin.gameSlug,
					prov: liveWin.providerSlug,
					tile: `${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
					alt: `${liveWin.gameSlug} by ${liveWin.providerSlug}`
				}}
				thumbnailBig
				showOverlay={false}
				width="60px"
				height="80px"
				maxWidth="60px"
				maxHeight="80px"
			/>
		</a>

		<!-- Bottom info -->
		<div class="bottom">
			<Text
				type="body"
				bodySize="small"
				bodyWeight="bold"
				textColor="white"
				customStyle="font-size: 10px;"
				textAlign="center"
			>
				{truncatedUsername()}
			</Text>

			<div class="amount-row">
				<div class="currency-badge">
					<CurrencyIcon currency={getCurrency()} size={'13'} />
				</div>

				<Text
					type="body"
					bodySize="small"
					bodyWeight="bold"
					textColor="white"
					customStyle="font-size: 10px;"
				>
					{formatLargeNumbers(liveWin.paidCurrency)}
				</Text>
			</div>
		</div>
	</div>
</InfoCard>

<style>
	.simple-livewin {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		background: linear-gradient(
			0deg,
			var(--color-background-500) 0%,
			var(--color-background-900) 100%
		);
		border-radius: 8px;
		padding: 4px
}

	.tile-link {
		display: block
}

	.bottom {
		display: flex;
		width: 100%;
		flex-direction: column;
		padding: 4px
}

	.amount-row {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem
}

	.currency-badge {
		display: flex;
		height: 13px;
		width: 13px;
		align-items: center;
		justify-content: center
}
</style>
